import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import Icon from '../AppIcon';
import LeadFormButton from '../LeadFormButton';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();

  const navigationItems = [
    { name: 'Início', path: '/homepage', icon: 'Home' },
    { name: 'Catálogo', path: '/interactive-catalog', icon: 'Grid3X3' },
    { name: 'Materiais', path: '/materials', icon: 'Package' }
  ];

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  const isActivePath = (path) => {
    return location?.pathname === path;
  };

  return (
    <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
      isScrolled 
        ? 'bg-white shadow-premium border-b border-border' 
        : 'bg-white'
    }`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20 lg:h-24">
          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center space-x-1">
            {navigationItems?.map((item) => (
              <Link
                key={item?.path}
                to={item?.path}
                className={`flex items-center space-x-2 px-4 py-2 rounded-lg text-sm font-medium transition-all duration-300 ${
                  isActivePath(item?.path)
                    ? 'bg-primary text-primary-foreground shadow-forest'
                    : 'text-text-primary hover:text-primary hover:bg-muted'
                }`}
              >
                <Icon name={item?.icon} size={16} strokeWidth={2} />
                <span>{item?.name}</span>
              </Link>
            ))}
          </nav>

          {/* CTA Button */}
          <div className="hidden lg:flex items-center space-x-4">
            <LeadFormButton
              variant="outline"
              size="sm"
              iconName="Phone"
              iconPosition="left"
              className="border-primary text-primary hover:bg-primary hover:text-primary-foreground"
            >
              Consultoria
            </LeadFormButton>
            <LeadFormButton
              variant="default"
              size="sm"
              iconName="MessageCircle"
              iconPosition="left"
              className="bg-gradient-forest hover:shadow-forest"
            >
              WhatsApp
            </LeadFormButton>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={toggleMenu}
            className="lg:hidden p-2 rounded-lg text-text-primary hover:text-primary hover:bg-muted transition-colors duration-200"
            aria-label="Toggle menu"
          >
            <Icon name={isMenuOpen ? "X" : "Menu"} size={24} strokeWidth={2} />
          </button>
        </div>
      </div>
      {/* Mobile Menu */}
      <div className={`lg:hidden transition-all duration-300 ${
        isMenuOpen 
          ? 'max-h-screen opacity-100' :'max-h-0 opacity-0 overflow-hidden'
      }`}>
        <div className="bg-card border-t border-border shadow-premium-lg">
          <div className="px-4 py-6 space-y-4">
            {/* Primary Navigation */}
            <div className="space-y-2">
              {navigationItems?.map((item) => (
                <Link
                  key={item?.path}
                  to={item?.path}
                  onClick={closeMenu}
                  className={`flex items-center space-x-3 px-4 py-3 rounded-lg text-base font-medium transition-all duration-200 ${
                    isActivePath(item?.path)
                      ? 'bg-primary text-primary-foreground shadow-forest'
                      : 'text-text-primary hover:text-primary hover:bg-muted'
                  }`}
                >
                  <Icon name={item?.icon} size={20} strokeWidth={2} />
                  <span>{item?.name}</span>
                </Link>
              ))}
            </div>

            {/* Mobile CTAs */}
            <div className="pt-4 space-y-3">
              <LeadFormButton
                variant="default"
                fullWidth
                iconName="MessageCircle"
                iconPosition="left"
                className="bg-gradient-forest hover:shadow-forest"
              >
                Conversar no WhatsApp
              </LeadFormButton>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;